import * as actions from "./auth.actions";
import * as api from "./auth.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./auth.constants";
import * as hooks from "./auth.hooks";
import * as promises from "./auth.promises";
import reducer from "./auth.reducer";
import { saga } from "./auth.saga";
import * as selectors from "./auth.selectors";
import * as utils from "./auth.utils";
export * from "./auth.types";
export var REDUCER_KEY_AUTH_V2 = REDUCER_KEY;
export var authModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
